module.exports = __webpack_public_path__ + "img/dummy-load-data.ac3ac1a6.svg";